import type { ReactNode } from 'react';

// Pochi mattoni con i token iOS di Quick. Bersagli ≥ 44 px (L8): sulla pistola si tocca con i guanti.

export function Screen({ title, children, footer }: { title: string; children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col">
      <header className="sticky top-0 z-10 flex h-11 items-center justify-center border-b border-sep bg-fondo/95 px-4 text-[17px] font-semibold backdrop-blur">
        {title}
      </header>
      <main className="flex flex-1 flex-col gap-3 p-3">{children}</main>
      {footer && <footer className="sticky bottom-0 flex flex-col gap-2 border-t border-sep bg-fondo/95 p-3 backdrop-blur">{footer}</footer>}
    </div>
  );
}

export function Card({ children }: { children: ReactNode }) {
  return <section className="rounded-xl bg-scheda p-3 shadow-scheda">{children}</section>;
}

type Tone = 'primary' | 'secondary' | 'danger';

export function Button({ tone = 'primary', disabled, onClick, children }: { tone?: Tone; disabled?: boolean; onClick: () => void; children: ReactNode }) {
  const cls = {
    primary: 'bg-blu text-white',
    secondary: 'bg-riemp text-blu',
    danger: 'bg-riemp text-rosso-t',
  }[tone];
  return (
    <button type="button" disabled={disabled} onClick={onClick} className={`min-h-tocco rounded-xl px-4 text-[17px] font-semibold active:opacity-70 disabled:opacity-40 ${cls}`}>
      {children}
    </button>
  );
}

export function Hint({ tone, children }: { tone: 'warn' | 'bad' | 'ok' | 'info'; children: ReactNode }) {
  const cls = { warn: 'bg-arancio/15 text-arancio-t', bad: 'bg-rosso/15 text-rosso-t', ok: 'bg-verde/15 text-verde-t', info: 'bg-riemp text-sec' }[tone];
  return <div className={`rounded-lg px-3 py-2 text-[15px] ${cls}`}>{children}</div>;
}

export function ValueRow({ label, value, sub }: { label: string; value: string; sub?: string }) {
  return (
    <div className="flex items-baseline justify-between border-b border-sep py-2 last:border-b-0">
      <span className="text-[15px] text-sec">{label}</span>
      <span className="text-right">
        <span className="font-mono text-[20px] font-semibold">{value}</span>
        {sub && <span className="block text-[12px] text-ter">{sub}</span>}
      </span>
    </div>
  );
}

export function Field({ label, value, onChange, unit, inputMode = 'decimal', autoFocus }: { label: string; value: string; onChange: (v: string) => void; unit?: string; inputMode?: 'decimal' | 'text'; autoFocus?: boolean }) {
  return (
    <label className="flex items-center justify-between gap-2 border-b border-sep py-2 last:border-b-0">
      <span className="text-[15px] text-sec">{label}</span>
      <span className="flex items-center gap-1">
        <input
          className="min-h-tocco w-28 rounded-lg bg-riemp px-2 text-right font-mono text-[18px] outline-none focus:ring-2 focus:ring-blu"
          inputMode={inputMode}
          value={value}
          autoFocus={autoFocus}
          onChange={(e) => onChange(e.target.value)}
        />
        {unit && <span className="text-[15px] text-ter">{unit}</span>}
      </span>
    </label>
  );
}

export function Spinner({ label }: { label: string }) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 text-sec">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-riemp border-t-blu" />
      <span className="text-[15px]">{label}</span>
    </div>
  );
}
